import React from 'react';
import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Stack,
    Typography,
} from '@mui/material';

export default function ReleaseNotesDialog({
    open,
    onClose,
    entries = [],
    loading = false,
    error = '',
    suppressOnLogin = false,
    onSuppressChange,
    canDismiss = true,
}) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Releasenotes</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 1 }}>
                    {loading ? (
                        <Typography variant="body2" color="text.secondary">
                            Releasenotes werden geladen...
                        </Typography>
                    ) : error ? (
                        <Typography variant="body2" color="error">
                            {error}
                        </Typography>
                    ) : entries.length === 0 ? (
                        <Typography variant="body2" color="text.secondary">
                            Aktuell sind keine Releasenotes verfuegbar.
                        </Typography>
                    ) : (
                        entries.map((entry, index) => (
                            <Box key={`${entry.title || entry.version || entry.date}-${index}`}>
                                <Stack direction="row" spacing={1} alignItems="baseline" sx={{ flexWrap: 'wrap' }}>
                                    {entry.title && (
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                            {entry.title}
                                        </Typography>
                                    )}
                                    {entry.version && (
                                        <Typography variant="body2" color="text.secondary">
                                            Version {entry.version}
                                        </Typography>
                                    )}
                                    {entry.date && (
                                        <Typography
                                            variant={entry.title ? 'body2' : 'subtitle1'}
                                            color="text.secondary"
                                            sx={entry.title ? undefined : { fontWeight: 600 }}
                                        >
                                            {entry.date}
                                        </Typography>
                                    )}
                                </Stack>
                                <Stack component="ul" spacing={0.5} sx={{ pl: 2, mt: 1 }}>
                                    {entry.items.map((item, itemIndex) => (
                                        <Typography
                                            component="li"
                                            variant="body2"
                                            key={`${entry.title || entry.version || entry.date}-${itemIndex}`}
                                        >
                                            {item}
                                        </Typography>
                                    ))}
                                </Stack>
                            </Box>
                        ))
                    )}
                    {canDismiss && (
                        <FormControlLabel
                            control={(
                                <Checkbox
                                    checked={suppressOnLogin}
                                    onChange={onSuppressChange}
                                />
                            )}
                            label="Beim Login nicht mehr anzeigen"
                        />
                    )}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Schliessen</Button>
            </DialogActions>
        </Dialog>
    );
}
